import React from 'react';
import { Section } from '../ui/Section';
import { motion } from 'framer-motion';
export function CentralPromise() {
  return <Section background="gradient-pink" className="text-center" data-id="element-52">
      <motion.div initial={{
      opacity: 0,
      scale: 0.9
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 0.8
    }} className="max-w-4xl mx-auto" data-id="element-53">
        <h2 className="text-3xl md:text-5xl font-black text-slate-900 leading-tight mb-8" data-id="element-54">
          Podés dejar de vivir agotada sin dejar tu trabajo, sin abandonar tus
          estudios y sin exigirte más.
        </h2>

        <div className="inline-block bg-white/30 backdrop-blur-md px-8 py-4 rounded-full border border-white/50" data-id="element-55">
          <p className="text-lg md:text-xl text-slate-800 font-medium" data-id="element-56">
            En los primeros días vas a sentir más claridad mental, menos peso
            interno y alivio real.
          </p>
        </div>
      </motion.div>
    </Section>;
}